const Patties = () => {
  return (
    <section className="patties">
      <br />
      <label for="amount">
        <strong>How many patties would you like?</strong>
      </label>
      <br />
      <br />
      <input type="number" name="amount" className="amount" min="1" max="4" />
      <br />
      <br />
    </section>
  );
};

export default Patties;
